module.exports = __webpack_public_path__ + "7d6ec569621adcf960bed373bfedee40.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/sleeping-20.png
// module id = 1635
// module chunks = 0